import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Form, ModalFormFooter, getFieldProps, Modal, TextArea } from '@crx-dev/hss-react-components';
import { useMutation, useQueryClient } from 'react-query';
import { makeRequest } from '@crx-dev/hss-react-infrastructure/dist';
import { useUserInfo } from '../../../Infrastructure/auth/UseUserInfo';
import { Note } from '../types/Note';

interface NoteFormProps {
    registerId: string;
    entryId: string;
    onCancel: () => void;
    type: 'controldrugregister' | 'returneddrugregister';
    queryKey: 'controlled-entries' | 'returned-entries';
}

function NoteForm({ registerId, entryId, onCancel, type, queryKey }: NoteFormProps) {
    const userInfo = useUserInfo();
    const queryClient = useQueryClient();

    const addNoteMutation = useMutation<Note, unknown, any>(
        note =>
            makeRequest({
                method: 'POST',
                path: `/api/v1/${type}/${registerId}/entries/${entryId}/addnote`,
                data: { ...note }
            }),
        {
            onSuccess: async () => {
                onCancel();
                await queryClient.invalidateQueries([queryKey]);
            }
        }
    );

    const formik = useFormik({
        initialValues: {
            note: '',
            addedBy: userInfo.name
        },
        validationSchema: yup.object().shape({
            note: yup
                .string()
                .matches(/.+/, 'Required')
                .required('Required')
        }),
        onSubmit: values => {
            addNoteMutation.mutate(values);
        }
    });

    return (
        <Modal onCancel={onCancel} open={true} title="Add Note">
            <Form onSubmit={formik.handleSubmit}>
                <TextArea {...getFieldProps(formik, 'note')} label="Note" placeholder="Enter a note" />
                <ModalFormFooter
                    isSubmitting={addNoteMutation.isLoading}
                    submitError={addNoteMutation.isError}
                    submitButtonLabel="SAVE"
                    onCancel={onCancel}
                />
            </Form>
        </Modal>
    );
}

export default NoteForm;
